/* Publish by EComposer at 2026-09-30 16:58:06*/
                (function(){
                    const Func = (function() {
                        'use strict';
window.__ectimmers = window.__ectimmers ||{};window.__ectimmers["ecom-52hw2f5ryi7"]=  window.__ectimmers["ecom-52hw2f5ryi7"] || {};
if(!this.$el)return;const t=this.$el,e=t.querySelector(".ecom-text_view-more-btn"),i=t.querySelector(".ecom-text_view-less-btn"),n=t.querySelector(".text-content.ecom-html");!n||(e&&e.addEventListener("click",()=>{n.classList.remove("ecom-text--is-mark"),n.style.maxHeight="",e.style.display="none",i.style.display=""}),i&&i.addEventListener("click",()=>{n.classList.add("ecom-text--is-mark"),n.style.maxHeight="var(--ecom-text-height)",i.style.display="none",e.style.display=""}))

                    });
                    
                        document.querySelectorAll('.ecom-52hw2f5ryi7').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-52hw2f5ryi7', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-5plgt3ujn34').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-5plgt3ujn34', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-73ipaqrkxxh').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-73ipaqrkxxh', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-wopl92spt3').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-wopl92spt3', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-jjn2n4vgf3').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-jjn2n4vgf3', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-uirpwppofl').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-uirpwppofl', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-5i5wf8bachl').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-5i5wf8bachl', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-jl149x3pqie').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-jl149x3pqie', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-z8kkmu7ba78').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-z8kkmu7ba78', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-4ctxfojsv6l').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-4ctxfojsv6l', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-vaezadn9zbl').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-vaezadn9zbl', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-inyofextkei').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-inyofextkei', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-r866y10x6').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-r866y10x6', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-hd741sctufa').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-hd741sctufa', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-9z3pjr5u11v').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-9z3pjr5u11v', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-7miuhm2924y').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-7miuhm2924y', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-t0u3xqt3dva').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-t0u3xqt3dva', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-td8flq8cw3e').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-td8flq8cw3e', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-dl30ph0q7el').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-dl30ph0q7el', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-fxd5djs1fup').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-fxd5djs1fup', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-69ru8wyb07i').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-69ru8wyb07i', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-oyh4iz9bne').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-oyh4iz9bne', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-ul61ww9htbm').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-ul61ww9htbm', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-iewzkvbzxig').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-iewzkvbzxig', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-y0vbeyzoai').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-y0vbeyzoai', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-6auvubqkh2g').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-6auvubqkh2g', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-6z84l0wom1j').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-6z84l0wom1j', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-sed9cels66').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-sed9cels66', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-9mtbfebcfs').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-9mtbfebcfs', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-rrdukzdks8').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-rrdukzdks8', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-lcr5eg0kl5p').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-lcr5eg0kl5p', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-1txeapq6oyn').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-1txeapq6oyn', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-ui3oehlz9').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-ui3oehlz9', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-ql2b4m20epm').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-ql2b4m20epm', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-jpctw84bwr').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-jpctw84bwr', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-psip6hn8li').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-psip6hn8li', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-ealzzj3mg6').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-ealzzj3mg6', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-2v0ehzm345o').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-2v0ehzm345o', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-asv4cwa7js').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-asv4cwa7js', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-6bvxtokhh8w').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-6bvxtokhh8w', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-j67y5lh3eyb').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-j67y5lh3eyb', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-ctb4vc68uai').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-ctb4vc68uai', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-rxn3yd4nq68').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-rxn3yd4nq68', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-a3oum0f2be5').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-a3oum0f2be5', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-muliiudue7a').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-muliiudue7a', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-vh079s7epo').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-vh079s7epo', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-eqbbluwuryk').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-eqbbluwuryk', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-hdzwvexf5a7').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-hdzwvexf5a7', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-3y5obcitrq7').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-3y5obcitrq7', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-xt39ykhqqbe').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-xt39ykhqqbe', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-c6ibq0709fc').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-c6ibq0709fc', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-0cqqg5egdvvd').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-0cqqg5egdvvd', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-gun53lhgd0q').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-gun53lhgd0q', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-l51bdb289pb').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-l51bdb289pb', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-k30i1z2d0sr').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-k30i1z2d0sr', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-bif62dakg3').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-bif62dakg3', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-fzjzlildw9').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-fzjzlildw9', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-c3c5k0jl57u').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-c3c5k0jl57u', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-mcljctvrtjo').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-mcljctvrtjo', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-q6omys9yiur').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-q6omys9yiur', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-ktye5p52ja').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-ktye5p52ja', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-ylzyo1tmk3').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-ylzyo1tmk3', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-clw6cawd36s').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-clw6cawd36s', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-7pgy81pqpg7').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-7pgy81pqpg7', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-5br2414bbhb').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-5br2414bbhb', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-8qb3ix1gi4y').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-8qb3ix1gi4y', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-dzjdrq11vhj').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-dzjdrq11vhj', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-ph3ukfjdv3').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-ph3ukfjdv3', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-40zgv70mi5y').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-40zgv70mi5y', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-vmjjaqhr9ub').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-vmjjaqhr9ub', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-gf791l8mrs6').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-gf791l8mrs6', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-b4oi1wss2ba').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-b4oi1wss2ba', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-z6431y925b').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-z6431y925b', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-v73sstss0j7').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-v73sstss0j7', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-hbfpx593sd4').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-hbfpx593sd4', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-686ecs5zvl3').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-686ecs5zvl3', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-f4icdgjydf9').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-f4icdgjydf9', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-r8awgmtat09').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-r8awgmtat09', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-h993e9z5fpa').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-h993e9z5fpa', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-tb0g2wczx6e').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-tb0g2wczx6e', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-i75mxebhhf').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-i75mxebhhf', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-m63t7x94a1').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-m63t7x94a1', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-c6y5j22imfi').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-c6y5j22imfi', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-cusfmcg4oj').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-cusfmcg4oj', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-njd3g20lnbc').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-njd3g20lnbc', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-rwlrctit16f').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-rwlrctit16f', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-q2ilmn4prvb').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-q2ilmn4prvb', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-utjia22mq9').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-utjia22mq9', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-isain0vt6gr').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-isain0vt6gr', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-rfvzenzl9sa').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-rfvzenzl9sa', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-sfg6zg904ff').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-sfg6zg904ff', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-c6ynqhh0rpd').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-c6ynqhh0rpd', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-gn34yd2y25u').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-gn34yd2y25u', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-7m1k7kpr367').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-7m1k7kpr367', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-iz3xouszjn').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-iz3xouszjn', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-gb4vpwj2uld').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-gb4vpwj2uld', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-dgiz7an39t5').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-dgiz7an39t5', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-l3evwapbvcf').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-l3evwapbvcf', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-5joj8nzxiza').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-5joj8nzxiza', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-fxsi4dsjhsg').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-fxsi4dsjhsg', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-2ho7i1am438').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-2ho7i1am438', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-yi9aij5pivk').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-yi9aij5pivk', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-xqp54hxuap').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-xqp54hxuap', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-h5abdisq4i5').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-h5abdisq4i5', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-lwjmzqb9lu').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-lwjmzqb9lu', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-smvwg44np1p').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-smvwg44np1p', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-u9ls07qemf').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-u9ls07qemf', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-z9io90pxrd').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-z9io90pxrd', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-lj1dmgvlcrq').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-lj1dmgvlcrq', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-y0nom38j99c').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-y0nom38j99c', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-lunwfmfi78n').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-lunwfmfi78n', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-djozy8rocy').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-djozy8rocy', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-krn16s9vdp').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-krn16s9vdp', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-0nvvfqma0eao').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-0nvvfqma0eao', settings: {},isLive: true});
                        });
                    

                })();
            
                (function(){
                    const Func = (function() {
                        'use strict';
window.__ectimmers = window.__ectimmers ||{};window.__ectimmers["ecom-6trpdm3e6f7"]=  window.__ectimmers["ecom-6trpdm3e6f7"] || {};
if(!this.$el)return!1;const t=this.$el;this.settings.animation&&function(i){if(!t)return;const n=t.querySelector(".ecom__element--button");if(!n)return;let o=parseInt(i.settings.animation_loop_time)*1e3||6e3,s=1e3;window.__ectimmers["ecom-6trpdm3e6f7"]["0pwghpl8m"] = setInterval(function(){n.classList.add("animated"),setTimeout(function(){n.classList.remove("animated")},s)},o)}(this);var e=t.querySelector(".ecom__element--button");this.isLive&&e&&e.dataset.ecTrackingId&&e.addEventListener("click",function(i){if(window.Shopify&&window.Shopify.analytics){i.preventDefault();let n=window.EComposer.PAGE||window.EComposer.TEMPLATE||window.EComposer.SECTION||window.EComposer.BLOCK||{};const o=Object.assign({button_id:e.id,tracking_id:e.dataset.ecTrackingId},n);try{Shopify.analytics.publish("ec_custom_events",o)}catch(a){console.error("[EC Tracking] Error publishing analytics event:",a)}const s=e.getAttribute("href"),r=e.getAttribute("target");s&&s!=="#"&&s!=="javascript:void(0)"&&(r==="_blank"?window.open(s,"_blank"):setTimeout(function(){window.location.href=s},300))}},{once:!0}),this.isLive&&e&&e.dataset.eventTrackingFb&&e.addEventListener("click",function(i){window.fbq&&window.fbq("track",`${e.dataset.eventTrackingFb}`)},{once:!0})

                    });
                    
                        document.querySelectorAll('.ecom-6trpdm3e6f7').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-6trpdm3e6f7', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-hgfplpftdtc').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-hgfplpftdtc', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-9tskm2imr18').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-9tskm2imr18', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-asilzky973').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-asilzky973', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-f5kk9tifbp').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-f5kk9tifbp', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-b9trqlok2xm').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-b9trqlok2xm', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-ijj57rd4j99').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-ijj57rd4j99', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-gzc68r1ggii').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-gzc68r1ggii', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-vf19bn7r5jp').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-vf19bn7r5jp', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-rgnoqubukuh').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-rgnoqubukuh', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-ok7jlkwogrf').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-ok7jlkwogrf', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-puqejvj1jm8').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-puqejvj1jm8', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-6kdovoxdsut').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-6kdovoxdsut', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-9hg1yz72usg').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-9hg1yz72usg', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-zi0bmmoqp3').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-zi0bmmoqp3', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-2k3etd2cn0b').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-2k3etd2cn0b', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-58hk1vle2d5').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-58hk1vle2d5', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-1pbe4cg8kkli').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-1pbe4cg8kkli', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-kbb03etdirc').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-kbb03etdirc', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-js3lu8j3z1q').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-js3lu8j3z1q', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-5nyfcl6uu8a').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-5nyfcl6uu8a', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-w4chwnykjym').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-w4chwnykjym', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-cflnyw811b').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-cflnyw811b', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-lrx3sodlpge').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-lrx3sodlpge', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-dotl2ipz82u').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-dotl2ipz82u', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-orkndz7w97f').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-orkndz7w97f', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-ak8r6rnkeyt').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-ak8r6rnkeyt', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-w8ug2xl58s').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-w8ug2xl58s', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-2e8g3a3usr2').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-2e8g3a3usr2', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-0yelo8964jc').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-0yelo8964jc', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-z5t52o6z91').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-z5t52o6z91', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-841zow5quwv').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-841zow5quwv', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-ni5xi4yat6').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-ni5xi4yat6', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-tfwyosxlxd').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-tfwyosxlxd', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-vlz0voz84v').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-vlz0voz84v', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-roed4cgknb').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-roed4cgknb', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-vjrm14uayk').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-vjrm14uayk', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-h0ozp5dq50j').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-h0ozp5dq50j', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-e8ing7s8k1e').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-e8ing7s8k1e', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-grxc738y7ga').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-grxc738y7ga', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-4rvvbbfxhe8').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-4rvvbbfxhe8', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-8qzpqa016wv').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-8qzpqa016wv', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-vx9g3zepawe').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-vx9g3zepawe', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-kri1dsio7dg').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-kri1dsio7dg', settings: {"animation":false},isLive: true});
                        });
                    

                })();
            
                (function(){
                    const Func = (function() {
                        'use strict';
window.__ectimmers = window.__ectimmers ||{};window.__ectimmers["ecom-c4093dxztuj"]=  window.__ectimmers["ecom-c4093dxztuj"] || {};
var E,$,A,I,j,T;let t=this.$el;if(!t)return;let e=this.isLive;const i=(E=this.settings.disable_auto_close)!=null?E:!1,n=($=this.settings.disable_auto_close__tablet)!=null?$:!1,o=(A=this.settings.disable_auto_close__mobile)!=null?A:!1,s=(I=this.settings.scroll_on_mobile)!=null?I:!1,r=(j=this.settings.disable_effect)!=null?j:!1,a=(T=this.settings.close_all)!=null?T:!1,l=t.querySelector(":scope > .core__group--wrapper > .core__group--items"),c=l?l.querySelectorAll(":scope > .ecom-accordion__item"):[],d=Array.from(c).map(L=>L.querySelector(":scope > .ecom-accordion__title")).filter(Boolean);function m(L){const O=L.getBoundingClientRect();return O.top>=0&&O.left>=0&&O.bottom<=(window.innerHeight||document.documentElement.clientHeight)&&O.right<=(window.innerWidth||document.documentElement.clientWidth)}function g(){return window.EComposer.TEMPLATE_ID?window.screen.width:window.innerWidth}function _(L){return o&&L<768||n&&L>767&&L<1025||i&&L>1024}function b(L){if(!L)return;const O=L.style.transition;L.style.transition="none",L.style.height="auto";const B=L.scrollHeight;L.style.height="0px",L.offsetHeight,L.style.transition=O,requestAnimationFrame(()=>{const N=r?"auto":e?B+"px":"auto";L.style.height=N})}function y(L){L.classList.remove("ecom-item-active");const O=L.querySelector(":scope > .ecom-accordion__body");O&&(r||(O.style.height=O.scrollHeight+"px",O.offsetHeight),requestAnimationFrame(()=>{O.style.height="0px"}))}function v(L){let O=0;if(L.offsetParent)do O+=L.offsetTop;while(L=L.offsetParent);return O}function w(L){const O=Math.max(0,L),B=window.pageYOffset||document.documentElement.scrollTop,N=O-B;if(N===0)return;const Z=300;let U=null;function G(oe){U||(U=oe);const se=Math.min((oe-U)/Z,1),Y=se<.5?2*se*se:1-Math.pow(-2*se+2,2)/2;window.scrollTo(0,B+N*Y),se<1&&window.requestAnimationFrame(G)}window.requestAnimationFrame(G)}function k(L){w(v(L)-100)}function S(L,O=!1){L.forEach((B,N)=>{const Z=B.parentNode,U=Z.querySelector(":scope > .ecom-accordion__body");!r&&U&&U.classList.add("ecom-effect-accodion");const G=Z.classList.contains("ecom-item-active");U&&!a&&(O&&N===0||G)&&requestAnimationFrame(()=>{U.style.height=U.scrollHeight+"px"}),B.onclick=function(oe){var le,me;if(oe.preventDefault(),!e){window.dispatchEvent(new window.Event("renderScroll"));return}const se=g(),Y=this.parentNode,de=Y.parentNode,ge=de.querySelectorAll(":scope > .ecom-accordion__item"),ce=Array.from(ge).map(fe=>fe.querySelector(":scope > .ecom-accordion__title")).filter(Boolean),te=Y.querySelector(":scope > .ecom-accordion__body");Y.classList&&Y.classList.remove("ecom-item-group-init");const q=this.classList.contains("ecom-item-active"),J=_(se);if(q)J?(this.classList.remove("ecom-item-active"),Y.classList.remove("ecom-item-active"),y(Y)):(ge.forEach(y),ce.forEach(fe=>fe.classList.remove("ecom-item-active")));else{J||(ge.forEach(y),ce.forEach(Te=>Te.classList.remove("ecom-item-active"))),B.classList.add("ecom-item-active"),Y.classList.add("ecom-item-active");let fe=Y.closest(".ecom-accordion__body");for(;fe;)fe.style.height="auto",fe=(me=(le=fe.parentElement)==null?void 0:le.closest)==null?void 0:me.call(le,".ecom-accordion__body");!r&&te&&te.classList.add("ecom-effect-accodion"),b(te)}window.dispatchEvent(new window.Event("renderScroll"));const X=this,ue=s||se>1024;function K(){window.dispatchEvent(new window.Event("renderScroll")),ue&&!m(X)&&k(X)}if(ue&&!r){let fe;const Te=function(ze){ze.propertyName==="height"&&(clearTimeout(fe),fe=setTimeout(()=>{de.removeEventListener("transitionend",Te),K()},50))};de.addEventListener("transitionend",Te),setTimeout(()=>{de.removeEventListener("transitionend",Te),K()},600)}else requestAnimationFrame(()=>{setTimeout(K,100)})}})}S(d,!0),a||requestAnimationFrame(()=>{const L=t.querySelector(".ecom-item-group-init");L&&L.classList.remove("ecom-item-group-init")});function z(){const L=window.location.hash;if(L){const O=t.querySelector(`[data-target="${L}"]`);if(O){O.click(),O.dispatchEvent(new MouseEvent("mouseover",{bubbles:!0,cancelable:!0,view:window}));const Z=O.getBoundingClientRect().top+window.pageYOffset-window.innerHeight/2;w(Z)}}}requestAnimationFrame(()=>{setTimeout(z,100)}),window.addEventListener("resize",()=>S(d)),window.addEventListener("hashchange",z,!1)

                    });
                    
                        document.querySelectorAll('.ecom-c4093dxztuj').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-c4093dxztuj', settings: {"disable_auto_close":false,"disable_auto_close__tablet":true,"disable_effect":false,"close_all":true},isLive: true});
                        });
                    

                })();
            
                (function(){
                    const Func = (function() {
                        'use strict';
window.__ectimmers = window.__ectimmers ||{};window.__ectimmers["ecom-3p2m2zq5ue"]=  window.__ectimmers["ecom-3p2m2zq5ue"] || {};
if(!this.settings||!this.$el)return;const t=this.$el,e=this.isLive,i=this.settings.loop,n=this.settings.autoplay,o=this.settings.lazyload||!1,s=this.settings.player_controls||!1,r=this.settings.pause_on_hover||!1,a=this.settings.click_to_play_pause,l=this.settings.play_on_lightbox||!1,c=1;let d=t.querySelector(".ecom-video_overlay-icon");const m=t.querySelector(".ecom-video-poster");let g;g=d&&d.querySelector(".ecom-video-icon-play");const _=t.querySelector(".ecom-element_video-iframe");o&&setTimeout(function(){b(_)},500);function b($){let A={root:null,rootMargin:"0px",threshold:.5};new IntersectionObserver(w,A).observe($)}function y($,A){let I={handleMouseenter:j,handleMouseleave:T,handleEnded:L};function j(){$.readyState>=c&&$.pause()}function T(){$.readyState>=c&&$.play()}function L(){v($,I)}if(r){$.addEventListener("mouseenter",j),$.addEventListener("mouseleave",T);let O=t.querySelector(".ecom-video_link-extra");O&&O.href&&(O.addEventListener("mouseenter",j),O.addEventListener("mouseleave",T)),A||$.addEventListener("ended",L)}}function v($,A){if(A){const{handleMouseenter:I,handleMouseleave:j,handleEnded:T}=A;let L=t.querySelector(".ecom-video_link-extra");$.removeEventListener("mouseenter",I),$.removeEventListener("mouseleave",j),$.removeEventListener("ended",T),L&&L.href&&(L.removeEventListener("mouseenter",I),L.removeEventListener("mouseleave",j))}}function w($,A){$.forEach(function(I){if(I.isIntersecting){const j=I.target.querySelector("video source"),T=I.target.querySelector("video"),L=I.target.querySelector("iframe");if(T&&j&&(j.src=j.dataset.source,T.load(),T.addEventListener("loadeddata",function(){n&&T.play()})),L){let O=L.dataset.srcVideo;L.setAttribute("src",O)}A.unobserve(I.target)}})}let k=t.querySelector(".ecom_video"),S=t.querySelector(".ecom_iframe");a&&k.addEventListener("click",()=>{k.readyState>=c&&(k.paused?k.play():k.pause())}),n&&(d&&d.classList.remove("ecom-overlay"),g&&(g.style.display="none"),m&&(m.style.display="none")),k&&!i&&k.addEventListener("ended",function(){m&&(m.style.display="block"),d&&d.classList.add("ecom-overlay"),g&&(g.style.display="block")}),d&&d.addEventListener("click",()=>{if(this.settings.source=="hosted"||this.settings.source=="uploaded"&&k)m&&(m.style.display="none"),k.autoplay=!0,k.play(),d.classList.remove("ecom-overlay"),g.style.display="none";else if(S){let $=S.getAttribute("src");$.includes("autoplay=0")?$=$.replace("autoplay=0","autoplay=1"):$=$+"&autoplay=1",S.setAttribute("src",$),l?setTimeout(()=>{$=$.replace("autoplay=1","autoplay=0"),S.setAttribute("src",$)},100):(m&&(m.style.display="none"),d.classList.remove("ecom-overlay"),g.style.display="none")}}),k&&(e&&!m&&y(k,i),m&&m.addEventListener("click",function(){m.style.display="none",k.play(),e&&y(k,i)}),r||k.addEventListener("pause",function(){m&&(m.style.display="block"),d&&d.classList.add("ecom-overlay"),g&&(g.style.display="block")}),!s&&d&&k.addEventListener("click",function(){k.pause()})),t.querySelectorAll("[data-ec-tracking-id]").forEach(function($){$.dataset.ecTrackingId&&$.addEventListener("click",function(){window.Shopify.analytics&&Shopify.analytics.publish("ec_custom_events",{button_id:$.id,tracking_id:$.dataset.ecTrackingId})},{once:!0})});const z=t.querySelector("[ecom-modal]");if(z&&this.settings.image_overlay&&l&&window.EComModal){const $=z.dataset.width,A=z.dataset.height;var E=this.id;new window.EComModal(z,{cssClass:[E,"ecom-core","ecom-core-simulator"],onOpen:function(){var I=document.querySelector(".ecom-modal."+E);if(I){const j=I.querySelector(".ecom-modal-box__content");j.classList.add("ecom-element_video-iframe");const T={width:$,height:A};Object.assign(j.style,T)}},onClose:function(){var I=document.querySelector(".ecom-modal."+E);if(I){const j=I.querySelector(".ecom-element_video-iframe iframe");j&&(j.src="")}}})}

                    });
                    
                        document.querySelectorAll('.ecom-3p2m2zq5ue').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-3p2m2zq5ue', settings: {"loop":false,"player_controls":true,"source":"youtube","image_overlay":true},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-tlq8f3x9qwf').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-tlq8f3x9qwf', settings: {"loop":false,"autoplay":false,"player_controls":true,"click_to_play_pause":true,"source":"youtube","image_overlay":true},isLive: true});
                        });
                    

                })();
            
                (function(){
                    const Func = (function() {
                        'use strict';
window.__ectimmers = window.__ectimmers ||{};window.__ectimmers["ecom-9cwq5nu8dx6"]=  window.__ectimmers["ecom-9cwq5nu8dx6"] || {};
if(this.settings.link==="lightbox"&&this.settings.lightbox==="yes"&&window.EComModal&&this.$el){var t=this.$el.querySelector("[ecom-modal]");new window.EComModal(t,{cssClass:["ecom-container-lightbox-"+this.id]})}let e=this.$el;if(!e)return;function i(o){const s=o.getBoundingClientRect();return s.top>=0&&s.left>=0&&s.bottom-o.offsetHeight/2<=(window.innerHeight||document.documentElement.clientHeight)&&s.right<=(window.innerWidth||document.documentElement.clientWidth)}function n(){let o=e.querySelector(".ecom-element.ecom-base-image"),s=e.closest(".core__row--columns");o&&(i(o)?(o.classList.add("image-highlight"),s.setAttribute("style","z-index: unset")):(o.classList.remove("image-highlight"),s.setAttribute("style","z-index: 1")))}this.settings.highligh_on_viewport&&window.addEventListener("scroll",function(){n()})

                    });
                    
                        document.querySelectorAll('.ecom-9cwq5nu8dx6').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-9cwq5nu8dx6', settings: {"link":"custom","lightbox":"no"},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-icnqersk1uo').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-icnqersk1uo', settings: {"link":"custom","lightbox":"no"},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-ih5yfji9g48').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-ih5yfji9g48', settings: {"link":"custom","lightbox":"no"},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-vm53uc3jg5').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-vm53uc3jg5', settings: {"link":"custom","lightbox":"no"},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-ckcop2b396e').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-ckcop2b396e', settings: {"link":"custom","lightbox":"no"},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-xh23hg285nk').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-xh23hg285nk', settings: {"link":"custom","lightbox":"no"},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-fz8dnbd906t').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-fz8dnbd906t', settings: {"link":"custom","lightbox":"no"},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-e7qmaprqt3m').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-e7qmaprqt3m', settings: {"link":"custom","lightbox":"no"},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-grb1ljkykzs').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-grb1ljkykzs', settings: {"link":"custom","lightbox":"no"},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-ev5648frh89').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-ev5648frh89', settings: {"link":"none","lightbox":"no"},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-gb51dlikv66').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-gb51dlikv66', settings: {"link":"none","lightbox":"no"},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-x1ht8l0m3tf').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-x1ht8l0m3tf', settings: {"link":"custom","lightbox":"no"},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-qmujfhotzj8').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-qmujfhotzj8', settings: {"link":"custom","lightbox":"no"},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-jrz9e1zdp3').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-jrz9e1zdp3', settings: {"link":"custom","lightbox":"no"},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-80xob3g6kih').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-80xob3g6kih', settings: {"link":"custom","lightbox":"no"},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-n370f4g4h8').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-n370f4g4h8', settings: {"link":"custom","lightbox":"no"},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-8tf1kdo51fq').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-8tf1kdo51fq', settings: {"link":"custom","lightbox":"no"},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-tr7kdjvxcpa').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-tr7kdjvxcpa', settings: {"link":"none","lightbox":"no"},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-oniz6d99z0h').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-oniz6d99z0h', settings: {"link":"none","lightbox":"no"},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-drcvt8jgo98').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-drcvt8jgo98', settings: {"link":"custom","lightbox":"no"},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-y2v9x6mdhq8').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-y2v9x6mdhq8', settings: {"link":"custom","lightbox":"no"},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-0nca049mekt').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-0nca049mekt', settings: {"link":"custom","lightbox":"no"},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-v3zyctq6tig').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-v3zyctq6tig', settings: {"link":"custom","lightbox":"no"},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-qxgvm22zf0k').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-qxgvm22zf0k', settings: {"link":"none","lightbox":"no"},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-9t6o9qxpvy4').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-9t6o9qxpvy4', settings: {"link":"custom","lightbox":"no"},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-oc1awfo4fn8').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-oc1awfo4fn8', settings: {"link":"custom","lightbox":"no"},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-2ecihpne3k9').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-2ecihpne3k9', settings: {"link":"custom","lightbox":"no"},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-3vandvzfkzi').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-3vandvzfkzi', settings: {"link":"custom","lightbox":"no"},isLive: true});
                        });
                    

                })();
            
;try{
 
} catch(error){console.error(error);}